import { useMemo } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { VenueStatuses } from "~enums/venueStatuses.ts";
import type { LabelValue } from "~types/labelValue.ts";
import CustomSelect from "../CustomSelect";

type Props = {
  className?: string;
  disabled?: boolean;
  defaultValue?: string | { value: string; label: string }[];
  placeholder?: string;
  multiple?: boolean;
  value?: LabelValue | LabelValue[];
  onChange?: (value: LabelValue | LabelValue[] | undefined) => void;
};

const SelectVenueStatus = (props: Props) => {
  const { className, disabled, defaultValue, multiple } = props;
  const { formatMessage } = useIntl();
  const options = useMemo(
    () =>
      Object.values(VenueStatuses).map((value) => ({
        value,
        label: value,
      })),
    [formatMessage],
  );

  return (
    <CustomSelect
      style={{ minWidth: "130px" }}
      value={props.value}
      showSearch
      defaultValue={defaultValue}
      onChange={(_, option) => {
        if (multiple) {
          props.onChange?.(option as { value: string; label: string }[]);
        } else {
          props.onChange?.(option as { value: string; label: string });
        }
      }}
      options={options}
      placeholder={props.placeholder || <FormattedMessage id="venueStatus" />}
      allowClear
      className={className}
      disabled={disabled}
      mode={multiple ? "multiple" : undefined}
    />
  );
};

export default SelectVenueStatus;
